export const handleRequestError = (error) => {
  if (error.response) {
    return error.response.data.error;
  } else if (error.message && error.message === "Network Error") {
    return "Error en la red";
  }
};
